import { Comedian } from "@punchup/data/legacy";
import dayjs from "dayjs";

// sort unfollowed comedians by published at date
export const sortByPublishedAtDate = (a: Comedian, b: Comedian) => {
  if (!a.published_at) {
    return 1;
  } else if (!b.published_at) {
    return -1;
  }

  const publishedAtA = dayjs(a.published_at).toDate();
  const publishedAtB = dayjs(b.published_at).toDate();

  if (publishedAtA > publishedAtB) {
    return -1;
  } else if (publishedAtA < publishedAtB) {
    return 1;
  }

  return -1;
};

// sort unfollowed comedians by ranking score
export const sortByRankingScore = (
  a: { score: number },
  b: { score: number }
) => {
  const publishedAtA = a.score;
  const publishedAtB = b.score;

  if (publishedAtA > publishedAtB) {
    return -1;
  } else if (publishedAtA < publishedAtB) {
    return 1;
  }

  return -1;
};
// sort the remaining comedians randomly
export const sortRandomly = () => 0.5 - Math.random();
